import { For, Show, type JSX } from "solid-js";
import { CoordCard } from "../../components/CoordCard";
import { VirtualGrid } from "../../components/VirtualGrid";
import { CoordList } from "../catalog/list/CoordList";
import type { GridColumns, ViewMode } from "../preferences/types";
import { styles } from "../../styles";
import type { ColorFilters, CoordEntry, CoordItem } from "../../types";

type Props = {
  entries: CoordEntry[];
  loading: boolean;
  error?: unknown;
  missingItemIds: string[];
  viewMode: ViewMode;
  gridColumns: GridColumns;
  canUpdateOwnership: boolean;
  showItemQr: boolean;
  qrCycleIntervalMs: number;
  isSelected: (item: CoordItem) => boolean;
  onToggle: (item: CoordItem) => void;
  onPreviewItem: (item: CoordItem) => void;
  onPreviewEntry: (entry: CoordEntry) => void;
  isOwnershipPending: (item: CoordItem) => boolean;
  onOwnershipChange: (item: CoordItem, owned: boolean) => void;
  onQrOpen: (item: CoordItem) => void;
  onBrandFilter: (brand: string) => void;
  onScrollPositionChange: (scrolled: boolean) => void;
  toolbar: JSX.Element;
  colorFilters: ColorFilters;
};

export function MixCoordinateList(props: Props) {
  return (
    <main class={props.viewMode === "list" ? styles.mainList : styles.main}>
      <Show when={props.viewMode !== "list"}>{props.toolbar}</Show>
      <Show when={props.error}>
        <div class={styles.alert} role="alert">ミックスコーデを読み込めませんでした: {String(props.error)}</div>
      </Show>
      <Show when={props.missingItemIds.length > 0}>
        <div class={styles.alert} role="alert">
          現在のコーデデータから特定できないパーツがあります。
          <ul><For each={props.missingItemIds}>{(id) => <li>{id}</li>}</For></ul>
        </div>
      </Show>
      <Show when={!props.loading && !props.error && props.entries.length === 0}>
        <p class={styles.empty}>条件に一致するミックスコーデがありません。</p>
      </Show>
      <Show
        when={props.viewMode !== "list"}
        fallback={<CoordList
          entries={props.entries}
          isSelected={props.isSelected}
          onToggle={props.onToggle}
          canUpdateOwnership={props.canUpdateOwnership}
          showItemQr={props.showItemQr}
          qrCycleIntervalMs={props.qrCycleIntervalMs}
          isOwnershipPending={props.isOwnershipPending}
          onOwnershipChange={props.onOwnershipChange}
          onQrOpen={props.onQrOpen}
          onPreviewEntry={props.onPreviewEntry}
          onScrollPositionChange={props.onScrollPositionChange}
          onBrandFilter={props.onBrandFilter}
          entryBrandOnly
          toolbar={props.toolbar}
          colorFilters={props.colorFilters}
        />}
      >
        <VirtualGrid
          items={props.entries}
          columns={props.gridColumns}
          mode="grid"
          class={styles.grid}
          busy={props.loading}
          getKey={(entry) => entry.key}
        >
          {(entry) => (
            <CoordCard
              entry={entry}
              showParentImage={false}
              isSelected={props.isSelected}
              onToggle={props.onToggle}
              onPreviewItem={props.onPreviewItem}
              onPreviewEntry={props.onPreviewEntry}
              canUpdateOwnership={props.canUpdateOwnership}
              showItemQr={props.showItemQr}
              isOwnershipPending={props.isOwnershipPending}
              onOwnershipChange={props.onOwnershipChange}
              onQrRegistration={props.onQrOpen}
              onBrandFilter={props.onBrandFilter}
              colorFilters={props.colorFilters}
            />
          )}
        </VirtualGrid>
      </Show>
    </main>
  );
}
